import {
  LayoutDashboard, MessagesSquare, Send, Users2, ListChecks, Megaphone,
  FileText, Workflow, Calendar, BarChart3, Plug, KeyRound, UserCog,
  ScrollText, CreditCard, Settings, QrCode,
} from "lucide-react";

export const NAV_ITEMS = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, active: true, perm: "dashboard.view" },
  { to: "/conversations", label: "Conversazioni", icon: MessagesSquare, perm: "conversations.view" },
  { to: "/quick-send", label: "Invio rapido", icon: Send, perm: "conversations.view" },
  { to: "/contacts", label: "Contatti", icon: Users2, perm: "contacts.view" },
  { to: "/lists", label: "Liste", icon: ListChecks, perm: "contacts.view" },
  { to: "/campaigns", label: "Campagne", icon: Megaphone, perm: "campaigns.view" },
  { to: "/templates", label: "Template", icon: FileText, perm: "campaigns.view" },
  { to: "/automations", label: "Automazioni", icon: Workflow, perm: "automations.view" },
  { to: "/calendar", label: "Calendario", icon: Calendar, perm: "dashboard.view" },
  { to: "/statistics", label: "Statistiche", icon: BarChart3, perm: "statistics.view" },
  { to: "/qr-gateway", label: "QR Gateway", icon: QrCode, active: true, perm: "integrations.view" },
  { to: "/integrations", label: "Integrazioni", icon: Plug, active: true, perm: "integrations.view" },
  { to: "/keys", label: "API", icon: KeyRound, active: true, perm: "apikeys.view" },
  { to: "/users", label: "Utenti", icon: UserCog, active: true, perm: "users.view" },
  { to: "/audit-logs", label: "Audit log", icon: ScrollText, active: true, perm: "audit.view" },
  { to: "/billing", label: "Fatturazione", icon: CreditCard, active: true, perm: "billing.view" },
  { to: "/settings", label: "Impostazioni", icon: Settings, active: true, perm: "settings.view" },
];

export const MOBILE_NAV = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/conversations", label: "Chat", icon: MessagesSquare },
  { to: "/contacts", label: "Contatti", icon: Users2 },
  { to: "/statistics", label: "Stats", icon: BarChart3 },
  { to: "/settings", label: "Altro", icon: Settings },
];
